import { AxiosResponse } from 'axios';
import $api from './instance';
import { Chat, ChatsResponse, Message, SendMessageRequest } from '@/types';

export async function getChatsRequest(): Promise<
  AxiosResponse<ChatsResponse[]>
> {
  return $api.get('/chats');
}

export async function getChatRequest(
  chatId: number,
): Promise<AxiosResponse<Chat>> {
  return $api.get(`/chats/${chatId}`);
}

export async function getChatByParticipantRequest(
  userId: number,
): Promise<AxiosResponse<Chat>> {
  return $api.get(`/chats/participant/${userId}`);
}

export async function createChatRequest(participantsIds: number[]) {
  return $api.post('/chats/create', participantsIds);
}

export async function addUserToChatRequest(chatId: number, userId: number) {
  return $api.post(`/chats/${chatId}/add-user/${userId}`);
}

export async function getChatMessagesRequest(
  chatId: number,
): Promise<AxiosResponse<Message[]>> {
  return $api.get(`/chats/${chatId}/messages`);
}

export async function sendMessageByParticipantRequest(
  chatId: number,
  data: SendMessageRequest,
) {
  return $api.post(`/chats/participant/${chatId}/send-message`, data);
}

export async function sendMessageRequest(
  chatId: number,
  data: SendMessageRequest,
) {
  return $api.post(`/chats/${chatId}/send-message`, data);
}

export async function createMessageRequest(chatId: number, text: string) {
  return $api.post(`/chats/${chatId}/messages`, { text });
}

export async function readMessageRequest(chatId: number, messageId: number) {
  return $api.patch(`/chats/${chatId}/messages/${messageId}`);
}

export async function deleteMessageRequest(chatId: number, messageId: number) {
  return $api.delete(`/chats/${chatId}/messages/${messageId}`);
}

export async function deleteChatRequest(chatId: number) {
  return $api.delete(`/chats/${chatId}`);
}

export async function getChatParticipantsRequest(chatId: number) {
  return $api.get(`/chats/${chatId}/participants`);
}
